import { Card, Skeleton, Row, Col } from 'antd';

interface StatCardSkeletonProps {
  count?: number;
}

export function StatCardSkeleton({ count = 4 }: StatCardSkeletonProps) {
  return (
    <Row gutter={[16, 16]}>
      {Array.from({ length: count }, (_, i) => (
        <Col xs={24} sm={12} lg={6} key={i}>
          <Card>
            <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
            <br />
            <Skeleton.Input active size="large" style={{ width: 80 }} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}
